import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { crudConfig } from '../../../conf/listItems';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey } from './useGetListById';

// Config
import { uiConfig } from '../../../conf/lists';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.LIST_ITEM);

export const useDeleteListItem = ({ sessionToken, listId, onSuccessCb, onErrorCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: (listItemId) => Client.delete(sessionToken, listItemId),
        onSuccess: (data) => {
            updateCacheArray({
                queryKey: getQueryKey(listId),
                action: CACHE_ACTIONS.REMOVE,
                primaryKey: uiConfig.primaryKey,
                dataTransform: ({ oldData, targetItem }) => {
                    if (oldData) {
                        const listItemsCopy = [...(oldData?.cdsListItems ?? [])];
                        const targetIndex = listItemsCopy.findIndex(
                            (item) => item[crudConfig.primaryKey] === targetItem
                        );

                        if (targetIndex > -1) {
                            listItemsCopy.splice(targetIndex, 1);
                        }

                        return {
                            ...oldData,
                            cdsListItems: listItemsCopy
                        };
                    } else {
                        return oldData;
                    }
                },
                data
            });
            onSuccessCb?.();
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        refetchOnWindowFocus: false
    });
};
